import { Directive, OnInit, inject, input } from '@angular/core';

import { DatabaseNotificationType } from '@shared/services/notifications';
import { PrimaryNotificationComponent } from './primary-notification/primary-notification.component';
import { DashboardNotification } from './dashboard-notification';

@Directive({
  selector: '[appLeadStatusChangeNotification]',
})
export class LeadStatusChangeNotificationDirective implements OnInit {
  private primaryNotificationComponent = inject(PrimaryNotificationComponent, { host: true });

  readonly notificationData = input.required<DatabaseNotificationType>();

  ngOnInit() {
    const { patientId, isLead } = this.notificationData().data;
    const timestamp = this.notificationData().ts;

    const icon = 'next_week';
    const link = `/therapist/assigned-patients/patient-profile/${patientId}`;
    const title = 'Lead Therapist Change';
    const message = `You ${isLead === 'true' ? 'have been made' : 'are no longer'} lead therapist for a patient.`;
    const readAtTime = this.notificationData().read;
    const id = this.notificationData().id;

    this.primaryNotificationComponent.notification.set(
      new DashboardNotification(icon, link, title, message, timestamp, readAtTime, id)
    );
  }
}
